var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangelogHidr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.124,
    height: 33.122,
    viewBox: "0 0 15.124 33.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hidr-changelog",
    transform: "translate(0.28 0.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "body",
    d: "M134.4,67.364a.76.76,0,0,1,.758.76V97.887a.76.76,0,0,1-.758.76h-12.18a.76.76,0,0,1-.76-.76V68.123a.76.76,0,0,1,.76-.76H134.4m0-.463h-12.18A1.221,1.221,0,0,0,121,68.123V98.3a1.221,1.221,0,0,0,1.222,1.221H134.4a1.221,1.221,0,0,0,1.221-1.221V68.123A1.221,1.221,0,0,0,134.4,66.9Z",
    transform: "translate(-121.03 -66.94)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "camera",
    cx: 0.78,
    cy: 0.78,
    r: 0.78,
    transform: "translate(6.503 1.648)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "square-menu",
    transform: "translate(3.14 29.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19430",
    "data-name": "Rectangle 19430",
    width: 0.701,
    height: 0.701,
    transform: "translate(0.097 0.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75153",
    "data-name": "Path 75153",
    d: "M212.082,861v.891h-.891V861h.891m0,0h-.892v.893h.893V861Z",
    transform: "translate(-211.19 -861)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle-menu",
    transform: "translate(6.985 29.864)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1933",
    "data-name": "Ellipse 1933",
    cx: 0.36,
    cy: 0.36,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(0.103 0.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75154",
    "data-name": "Path 75154",
    d: "M306.1,861a.46.46,0,1,1-.46.459.46.46,0,0,1,.46-.459m0,0a.461.461,0,1,0,.46.46A.461.461,0,0,0,306.1,861Z",
    transform: "translate(-305.64 -861)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "triangle-menu",
    transform: "translate(10.831 29.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75155",
    "data-name": "Path 75155",
    d: "M280.74,796.155l.517-.305v.611Z",
    transform: "translate(-280.612 -795.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75156",
    "data-name": "Path 75156",
    d: "M399.756,860.281v.843l-.713-.421.713-.421m0,0-.716.421.716.421v-.844Z",
    transform: "translate(-399.04 -860.28)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangelogHidr);
export default __webpack_public_path__ + "static/media/changelog_hidr.577dccdc56fa89184d9d91f358f1deba.svg";
export { ForwardRef as ReactComponent };